var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#F3D4D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 45L43 26M43 26H25.2222M43 26V42.8889",
    stroke: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/InstaLogo.59c675948941e2741731b0165835eff8.svg";
export { ForwardRef as ReactComponent };